/**
* [Flags]
*/
export var AssigneeType;
(function (AssigneeType) {
    AssigneeType[AssigneeType["Account"] = 1] = "Account";
    AssigneeType[AssigneeType["Group"] = 2] = "Group";
    AssigneeType[AssigneeType["Role"] = 4] = "Role";
    AssigneeType[AssigneeType["AssignmentFolderRights"] = 8] = "AssignmentFolderRights";
})(AssigneeType || (AssigneeType = {}));
;
